// extracted by mini-css-extract-plugin
module.exports = {"docwrapper":"DocSearch-styles-module--docwrapper--24T9b"};